module.exports = __webpack_public_path__ + "img/balance-limit.ce88441e.svg";